import React, { useEffect, useState } from "react";
import styles from "./Privacy.module.css";
import { Header } from "@components";
import { useLoadReset } from "@/hooks";

export default function ScentPrivacy() {
  const loadReset = useLoadReset();
  const defaultState = {
    htmlContent: "",
  };
  const [state, setState] = useState(defaultState);
  const resetState = () => {
    setState(defaultState);
    loadReset();
  };

  useEffect(() => {
    fetch("/scent/privacy/privacy_251120.html")
      .then((res) => res.text())
      .then((res) => setState((s) => ({ ...s, htmlContent: res })));

    return () => {
      resetState();
    };
  }, []);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <Header title="향기(향기로운 기도)" isShare={false} />
        <div className={styles.pdfContainer}>
          <div className={styles.pdfContentArea}>
            <div
              className={styles.png}
              dangerouslySetInnerHTML={{ __html: state.htmlContent }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
